"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/components/SignupStepHeader.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _AuthFrame = require('web/components/AuthFrame');

// Only the result screens carry an icon (a tinted disc above the title); the
// form steps lead with their title, as in the approved frames.


const icons = {
  email: _react2.default.createElement(_AuthFrame.MailIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 11}} ),
  error: _react2.default.createElement(_AuthFrame.AlertIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}} ),
  ok: _react2.default.createElement(_AuthFrame.CheckIcon, { size: 26, __self: this, __source: {fileName: _jsxFileName, lineNumber: 13}} ),
}







const SignupStepHeader = ({ title, subtitle, iconType }) => (
  _react2.default.createElement('div', { className: "signup-step--header auth-stack" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 23}}
    ,  iconType && iconType in icons && (
      _react2.default.createElement('span', {
        className: _classBuilder2.default.call(void 0, 
          'auth-icon-circle',
          iconType === 'error' && 'auth-icon-circle--bad',
          iconType === 'ok' && 'auth-icon-circle--ok',
        ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}

        ,  icons[iconType] 
      )
    )
    ,  title && _react2.default.createElement('h1', { className: "auth-title signup-step--header--title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 35}},  title ) 
    ,  subtitle && _react2.default.createElement('div', { className: "auth-body signup-step--header--subtitle" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 36}},  subtitle ) 
  )
)

exports. default = SignupStepHeader
